<div class="search-box">
    <i class="fas fa-search default-icon-color search-icon"></i>
    <input type="text" class="search-input" [placeholder]="'defaults.search' | translation | async" [maxLength]="255" (keyup)="onKeyUp($event)" />
</div>
